import React, { useEffect,useMemo } from 'react';
import "./TableBookingDecision.css";
import Header from "../../../components/Header";
import useAuth from '../../../../customHooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import Remarks from "../../../components/Remarks/Remarks";
import axios from 'axios';
import { toast } from 'react-toastify';
import {baseUrl} from "../../../../common/baseUrl";
import axiosInstance from '../../../../axiosInstance/axiosInstance';
import { HOTEL_TIMEZONE } from "../../../../common/hotelTime";

export default function TableBookingDecision() {

    const navigate = useNavigate();
    const location = useLocation();

    const bookedRoomId = location.state?.bookedRoomId || "";
    const bookingId = location.state?.bookingId || "";
    const requestId = location.state?.requestId || "";
    const userId = location.state?.userId || "";
    const status = location.state?.status || "";
    const tableData = location.state?.tableData || {};
    

    // Refresh Handle
    useAuth();

    // Check Id
    useEffect(()=>{

        const checkId = ()=>{
            if(userId==="" || bookingId==="" || bookedRoomId===""){
                navigate("/bookings");
            }
        }
        checkId();
    },[]);

    const formattedStatus = useMemo(() => {
        return  status.replace('_', ' ');
    }, [status]);

    // Function to format the date (e.g., "07 Oct")
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        return `${day} ${month}`;
    };

    // Function to format the time (e.g., "22:11")
    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString([], {
            timeZone: HOTEL_TIMEZONE, hour: '2-digit', minute: '2-digit' });
    };

    // Close Request
    const closeRequest = async()=>{
        try{
            const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${requestId}/close`);
            // console.log("Request Cancelled : ",response.data);
            toast.success("Table Booking Request Cancelled Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}});

        }catch(error){
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        }
    }


    return (
    <div className='tableBookingDecision'>
        <Header title="Book a table at the hotel restaurant"  />
        <div className='table-view'>
            
            {/* Status */}
            <div className='table-view-status'>
                <h4>{formattedStatus}</h4>
            </div>

            {/* Guests */}
            <div className='tableView-data'>
                <h4>Number of guests</h4>
                <div className='tableView-inp'>
                    <h5>{tableData.number_of_people}</h5>
                </div>
            </div>

            {/* Date of Booking */}
            <div className='tableView-data'>
                <h4>Date of the booking</h4>
                <div className='tableView-inp'>
                    <h5>{formatDate(tableData.preferred_time)}</h5>
                </div>
            </div>

            {/* When do you want to book a table */}
            <div className='tableView-data'>
                <h4>When do you want to book a table</h4>
                <div className='tableView-inp'>
                    <h5>{formatTime(tableData.preferred_time)}</h5>
                </div>
            </div>

            {/* Comments */}
            {tableData.comments && 
                <div className='tableView-data'>
                    <h4>Comments</h4>
                    <div className='tableView-comment'>
                        <h5>{tableData.additional_comments}</h5>
                    </div>
                </div>
            }
        </div>

        {/* Remarks */}
        {
            tableData.remarks && 
            <Remarks para={tableData.remarks}/>
        }

        {/* Button */}
        {!(status === "Declined_Hotel" || status === "Completed_Hotel" || status === "Closed_Hotel" || status === "Declined_Guest" || status === "Closed_Guest") && (
            <div className='tableView-btn'>
                <button onClick={closeRequest}>Cancel Request</button>
            </div>
        )}

    </div>
  )
}
